import { render, staticRenderFns } from "./ctrl-show-text.vue?vue&type=template&id=36fbd9a2&scoped=true"
import script from "./ctrl-show-text.vue?vue&type=script&lang=js"
export * from "./ctrl-show-text.vue?vue&type=script&lang=js"
import style0 from "./ctrl-show-text.vue?vue&type=style&index=0&id=36fbd9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbd9a2",
  null
  
)

export default component.exports